import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { BannerFactory } from '../../factories/BannerFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Banner extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new BannerFactory
    this.pageComponent = true
  }

  elementIds() {
    return ['id', 'iconContainerId', 'iconId', 'ctaId', 'textId']
  }

  elementClasses() {
    return ['ctaClasses', 'iconContainerClasses', 'classes']
  }

  elementContents() {
    return ['text', 'hasIcon', 'class', 'icon', 'hasCTA', 'ctaText', 'ctaLink', 'isClosable']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id: 'ctaId', element: 'id', styles: 'ctaStyles', selector: '#', variation: null},
      {id: 'iconContainerId', element: 'id', styles: 'iconContainerStyles', selector: '#', variation: null},
      {id: 'iconId', element: 'id', styles: 'iconStyles', selector: '#', variation: null}
    ]
  }

  info() {
    return {
      name: 'Banner',
      icon: 'fa-bullhorn',
      variations: this.variationsInfo()
    }
  }
}